/*
 * @file endeca_search_control_v1.js
 * Endeca control class for the search page endeca instance.
*/

var site = site || {};
(function ($) {
  site.endeca = site.endeca || {};
  site.endeca.instances = site.endeca.instances || {};
  site.endeca.instances.search = site.endeca.instances.search || {};

  site.endeca.instances.search.control = site.endeca.generic.Class.create( site.endeca.control, {
    initialize: function( args ) {
      this._super( args );

      var that = this;

      if ( jQuery.address ) {
        jQuery.address.bind( 'change', that, function( event ) {
          that.search( { queryString: $H(event.parameters).toQueryString() } );

          // IE has issues with SWFAddress' initialize because of conflicts with iframes included on the page
          // The following will search unless it has already searched.
          window.setTimeout( function() {
            if ( !that.hasSearched ) {
              that.search( { queryString: $H(event.parameters).getQueryString() } );
            }
          }, 100);
        });
      } else {
        this.search();
      }

    },

    searchCompleted: function() {
      if ( !this._super() ) { return; }

      var that = this;
      if ( this.searchTerm ) {
        // enable wildcard
        // @todo comment out line below to see if the asterisk is removed
        // from the end of search term on not found searches
        // once coremetrics is enabled
        //this.wildcardSearch = true;

        if ( this.meta && this.meta.searchInfo && this.meta.searchInfo.didYouMean && !this.searchTerm.match(/\*/) ) {
          this.dym = this.meta.searchInfo.didYouMean;
        } else {
          this.meta.searchInfo.didYouMean = this.dym;
          this.dym = [];
        }

        this.results.products.resultData = this.catalogs.product.resultList;
        this.results.products.summaryResultData = this.meta.searchInfo;
        this.results.products.displayResults();
        this.results.products.show();

        if ( this.results.products.resultData.length ) {
          this.hasResults = true;

          // L2 hookup
          $(document).on('prodcat.status', function(e, data) {
            site.endeca.updateSearchInvStatus(data.products);
          });


          var $invStatusLists = $(".js-inv-status-list");
          $invStatusLists.each( function(){
            var invStatusList = site.productView.InvStatusList($(this));
          });

          var productIds = site.productView.collectProductIds();
          if (productIds.length > 0) {
            site.productView.loadL2Data(productIds);
          }

          if (typeof Drupal.settings.unshoppable_inventory_statuses !== 'undefined') {
            this.results.products.resultData.forEach(function(product) {
              site.setAddToBagShoppableByInventoryStatus && site.setAddToBagShoppableByInventoryStatus(product.defaultSku, 'btn-add-to-bag');
            });
          }
        } else {
          this.results.products.hide();
        }

        this.results.pagination.resultData = this.meta.pagination;
        this.results.pagination.displayResults();
        this.results.pagination.show();

        this.results.sorting.resultData = this.meta.sorting;
        this.results.sorting.displayResults();
        this.results.sorting.show();

        if ( !this.wildcardSearch ) {

          this.results.content.contentzones = this.configuration.contentzones;
          this.results.content.resultData = this.meta.supplementalContent;
          this.results.content.displayResults();

          if ( !jQuery.isEmptyObject( this.results.content.resultData ) ) {
            this.meta.processSearchInfo({ totalContentRecords: this.results.content.totalResults });
            //this.results.content.show();
            if ( this.results.content.hasSoloResults ) { this.hasResults = true; }
          } else {
            this.results.content.hide();
          }
        }
        if ( this.meta.dimensions.breadcrumbs ) {
          this.results.breadcrumbs.resultData = this.meta.dimensions.breadcrumbs;
          this.results.breadcrumbs.displayResults();
          this.results.breadcrumbs.show();
        } else {
          this.results.breadcrumbs.hide();
        }

        if ( this.meta.dimensions.refinements ) {
          this.results.refinements.resultData = this.meta.dimensions.refinements;
          this.results.refinements.displayResults();
          this.results.refinements.show();
          // @todo remove log
          //console.log(this.results.refinements.resultData);
        } else {
          this.results.refinements.hide();
        }

        jQuery(document).trigger('endeca.search.results.loaded', [ this ]);
      }

      if ( this.hasResults || this.wildcardSearch ) {
        this.results.summary.resultData = jQuery.extend( this.meta.searchInfo, { breadcrumbs: this.meta.dimensions.breadcrumbs } );
        this.results.summary.hasResults = this.hasResults;
        this.results.summary.displayResult();
      }

      this.displayResults();


      //additions
      //jQuery('.search-page__form .search-term').attr("placeholder", this.meta.searchInfo.searchTerm);
      var $searchSelect = $('.search-select');
      if($searchSelect.length){
          $searchSelect.selectBox();
      }

      var $searchSummary = $('.js-search-summary, .js-search-summary-dym, .js-search-summary-ac', '.js-search-summary');
      $searchSummary.each( function() {
        if($(this).length && $(this).html()){
          $(this).html(_.unescape($(this).html()));
        } else {
          $(this).next().removeClass('hidden');
        }
      });

      //Build Down Price Item Tempalte
      function sizeSelectBuildItem(itemData) {
        var optionItemHtml = itemData.attr('data-skusize') + '  <span class="product__price--non-sale">' + itemData.attr('data-formatted-price2') + '</span><span class="product__price--sale">' + itemData.attr('data-formatted-price') + '</span>';
        return optionItemHtml;
      }

      //Down Price Updated for Sized Products
      var productIds = site.productView.collectProductIds();
      productIds.map(function(index) {
        var id = index;
        var isMarkdownPrices = false;
        var searchSizeSelect = $('select.js-size-select-' + id);
        var priceNode = $('#product-' + id + ' .js-search-product-size');
        var price2 = priceNode.attr('data-price2');
        var currentPrice = priceNode.attr('data-current-price');
        var formattedPrice = priceNode.attr('data-formatted-price');
        var formattedPrice2 = priceNode.attr('data-formatted-price2');
        var productSize = priceNode.attr('data-skusize');
        var optionItemHtml = ''

        searchSizeSelect.find('option').each(function(index, item) {
          var optionItem = $(item);
          var customOptionItem = $('.js-size-select-' + id + '-selectBox-dropdown-menu').find("li");
          if (optionItem.attr('data-price2') !== '') {
            var optionTextHtml = sizeSelectBuildItem(optionItem);
            customOptionItem.eq(index).find("a").html(optionTextHtml);
            searchSizeSelect.attr('data-markdown-price', 1);
          }
        })
        if (searchSizeSelect.attr('data-markdown-price')) {
          var optionItem = searchSizeSelect.find('option:selected');
          if (optionItem.attr('data-price2') !== '') {
            var optionTextHtml = sizeSelectBuildItem(optionItem);
            var selectElement = $('.js-size-select-' + id + '-selectBox-dropdown-menu');
            searchSizeSelect.siblings("a.search-product__size-select").addClass('search-down-price-selectbox');
            selectElement.addClass('search-down-price-selectbox');
            searchSizeSelect.siblings("a.search-product__size-select").find("span.selectBox-label").html(optionTextHtml);
          }
          searchSizeSelect.selectBox().on('close', function() {
            var optionItem = $(this).find('option:selected');
            var optionTextHtml = sizeSelectBuildItem(optionItem);
            $(this).siblings("a.search-product__size-select").find("span.selectBox-label").html(optionTextHtml);
          });
        }

        //Down Price Updated for Sized Shaded Products
        var priceNode = $('#product-' + id + ' .js-search-product-size');
        if (priceNode.length > 0) {
          if (price2 && currentPrice && parseFloat(price2) > parseFloat(currentPrice)) {
            optionItemHtml = '<span class="product__price--non-sale">' + formattedPrice2 + '</span><span class="product__price--sale">' + formattedPrice + '</span> ' + productSize;

            priceNode.html(optionItemHtml);
          }
        }
      });
    }

  });


  site.endeca.updateSearchInvStatus = function(products) {
    var $sort = $('.search-product--sort');
    if(!$sort.length){ return; }
    //update inventory
    $.each(products, function(index, product) {
      var skus = product.skus;
      var $shadePicker = $(".js-shade-picker[data-product-id='" + product.PRODUCT_ID +"']");
      var $shadeSelect = $("select.js-sku-menu[data-product-id='" + product.PRODUCT_ID +"']");

      // if L2 lt Endeca
      // identify skus
      // hide from picker and dropdown

      // if L2 gt Endeca
      // do nothing

      // find rendered skus (sku base id)
      var endecaSkus = [];
      var $swatches = $('.swatches--single .swatch', $shadePicker);
      $swatches.each(function(index, swatch) {
        var skuBaseID = $(this).data('sku-base-id');
        endecaSkus.push('SKU'+skuBaseID);
      });

      // find skus (sku base id)
      var l2Skus = [];
      $.each(skus, function(index, sku) {
        var skuBaseID = sku.SKU_ID;
        l2Skus.push(skuBaseID);
      });

      var diffSkus = _.difference(endecaSkus, l2Skus);

      if(diffSkus.length){
        console.log( $('#product-'+product.PRODUCT_ID) );
        console.log(product);
        console.log('endecaSkus');
        console.log(endecaSkus);
        console.log('l2Skus');
        console.log(l2Skus);
        console.log('diffSkus');
        console.log(diffSkus);

        // place diff skus out of stock
        // will only effect skus rendered from endeca
        // $(diffSkus).each(function(index, sku) {
        //   var skuBase = sku;
        //   var skuBaseID = sku.replace('SKU','');
        //   var $swatch = $(".swatch[data-sku-base-id='" + skuBaseID +"']").parent('.swatches');
        //   if($swatch.length){
        //     try {
        //       var skuData = _.find(skus, function(sku){ return sku.SKU_ID == skuBase; });
        //       // add try catch
        //       if(skuData.INVENTORY_STATUS != 1){
        //         $swatch.attr('data-inventory','4');
        //         // and deal with dropdown
        //         //$("option[data-sku-base-id='"+ skuBaseID +"']",$shadeSelect).appendTo($shadeSelect);
        //       }
        //     }catch (e) {
        //       // no matching sku data
        //       $swatch.attr('data-inventory','4');
        //     }
        //   }
        // });

        // problem: rerouting inventory_status_updated event for these skus
        // outside of teh l2 data
        // specifically for the select.js-sku-menu
      }

      if($shadePicker.hasClass('nonshaded')){
        return true;
      }
      var inventoryOrder = {};
      $.each(skus, function(index, sku) {
        // update shade picker
        var skuBaseID = sku.SKU_ID;
        skuBaseID = skuBaseID.replace('SKU','');
        var $swatch = $(".swatch[data-sku-base-id='" + skuBaseID +"']").parent('.swatches');
        $swatch.attr('data-inventory',sku.INVENTORY_STATUS);
        if(inventoryOrder.hasOwnProperty(sku.INVENTORY_STATUS)){
          inventoryOrder[sku.INVENTORY_STATUS].push($swatch);
        }else{
          inventoryOrder[sku.INVENTORY_STATUS] = [$swatch];
        }
      });
      //reorder shadepicker
      //push inventory greater than one to the bottom of the list
      for (var key in inventoryOrder) {
        if(key != 1){
          $.each(inventoryOrder[key], function(index, product) {
            $shadePicker.append(product);
          });
        }
      }

      // grab select order from shadepicker
      var $swatches = $('.swatch',$shadePicker);
      var skuOrder = [];
      $swatches.each(function(index, swatch) {
        skuOrder.push($(swatch).attr('data-sku-base-id'));
      });
      //reorder shade select
      var $shadeSelect = $("select.js-sku-menu[data-product-id='" + product.PRODUCT_ID +"']");
      $.each(skuOrder, function(index, skuBaseID) {
        $("option[data-sku-base-id='"+ skuBaseID +"']",$shadeSelect).appendTo($shadeSelect);
        var skuDetails = $(document).data('SKU'+skuBaseID);
        if(skuDetails && skuDetails.isPreOrder) {
          var skuValue = $("option[data-sku-base-id='"+ skuBaseID +"']",$shadeSelect).text();
          $("option[data-sku-base-id='"+ skuBaseID +"']",$shadeSelect).text(skuValue + ' - ' + site.translations.product.pre_order);
        }
      });

      // trigger first sku
      var $firstSwatch = $(".swatch[data-sku-base-id='" + skuOrder[0] +"']");
      $firstSwatch.trigger('click');

    });

  };
})(jQuery);

